import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icons from '../icons';
import '../../styles/index.css';

export default function TermsAndConditions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }}>
            {/* Header */}
            <div style={{
                height: '50px', position: 'sticky', top: 0, left: '0px', right: '0px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
                alignItems: 'center', zIndex: 1000, backgroundColor: '#FFFFFF', borderBottom: '1px solid #E0E0E0'
            }}>
                <Link to="/" style={{ paddingLeft: '15px', color: 'green', textDecoration: 'none' }}>
                    <Icons icon="logo" size="160" color="#429a37" />
                </Link>
                <Link to="/" style={{ paddingRight: '20px', textDecoration: 'none', color: '#429a37', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: 500 }}>
                    ← Back to Home
                </Link>
            </div>

            {/* Content */}
            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
                <h1 style={{ fontSize: '36px', fontFamily: "'Roboto', sans-serif", fontWeight: 600, marginBottom: '10px', color: '#000000' }}>
                    Terms and Conditions
                </h1>
                <p style={{ fontSize: '14px', fontFamily: "'Roboto', sans-serif", color: '#666666', marginBottom: '40px' }}>
                    Last Updated: December 31, 2024
                </p>

                <div style={{ fontFamily: "'Roboto', sans-serif", lineHeight: '1.8', color: '#333333' }}>
                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>1. Introduction</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Welcome to Powerbox Energy Systems LLC ("Powerbox", "we", "us", or "our"). These Terms and Conditions ("Terms") govern your use of our website and the purchase of our products. 
                            By accessing our website or purchasing our products, you agree to be bound by these Terms.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>2. Products and Services</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Powerbox offers solar-powered energy systems including the Powerbox Pro. All product descriptions, specifications, and images are provided for informational purposes 
                            and may be subject to change without notice.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We strive to ensure all product information is accurate, but we do not warrant that product descriptions or other content is error-free, complete, or current.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>3. Warranty</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Powerbox products come with a 1-year warranty and a 10-year guarantee as specified in your purchase agreement. The warranty covers manufacturing defects 
                            and does not cover damage resulting from misuse, unauthorized modifications, or normal wear and tear.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            To claim warranty service, customers must contact our support team at Support@powerbox.com.ng with proof of purchase and details of the issue.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>4. Orders and Payment</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order for any reason, including but not limited to 
                            product availability, errors in pricing or product information, or suspected fraudulent activity.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Payment must be made in full before products are shipped or delivered. We accept various payment methods as indicated during the checkout process.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>5. Delivery and Installation</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Delivery times are estimates and not guaranteed. We will make reasonable efforts to deliver products within the estimated timeframe, but we are not 
                            liable for delays caused by circumstances beyond our control.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Installation guidance is provided for basic setup. For complex installations, we recommend consulting with a qualified professional.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>6. Customer Responsibilities</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Customers are responsible for:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>Providing accurate delivery and contact information</li>
                            <li>Proper installation and maintenance of Powerbox products</li>
                            <li>Following all safety guidelines and operating instructions</li>
                            <li>Ensuring adequate ventilation and appropriate environmental conditions for the product</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>7. Limitation of Liability</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            To the fullest extent permitted by law, Powerbox Energy Systems LLC shall not be liable for any indirect, incidental, special, consequential, or 
                            punitive damages arising out of or relating to the purchase or use of our products.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>8. Intellectual Property</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            The Powerbox name, logo, and all related trademarks are the property of Powerbox Energy Systems LLC. All content on this website, including text, 
                            images, and design, is protected by copyright and other intellectual property rights.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>9. Modifications</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our 
                            website or products after such changes constitutes acceptance of the modified Terms.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>10. Contact Information</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            For questions about these Terms and Conditions, please contact us:
                        </p>
                        <div style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <p><strong>Powerbox Energy Systems LLC</strong></p>
                            <p>Ad1, Makarfi Street</p>
                            <p>Constitution, Kaduna</p>
                            <p>Nigeria</p>
                            <p>Email: Support@powerbox.com.ng</p>
                            <p>Phone: 09070811425</p>
                        </div>
                    </section>
                </div>
            </div>

            {/* Footer */}
            <div style={{ backgroundColor: '#F5F5F5', padding: '20px', textAlign: 'center', marginTop: '40px', borderTop: '1px solid #E0E0E0' }}>
                <p style={{ fontSize: '14px', fontFamily: "'Roboto', sans-serif", color: '#666666' }}>
                    © 2024 Powerbox Energy Systems LLC. All Rights Reserved.
                </p>
            </div>
        </div>
    );
}
